import axios from "axios";
import {Where, WhereDocument} from "chromadb";
import {host} from "../feature/project/api";
import {headers} from "../feature/project/headers";

export async function aiChainPrompt(
    config: {
        projectId: string,
        prompt:
            {
                role: string,
                content: {
                    text: string
                }[]
            }[],
        model?: string,
        type?: 'text' | 'json',
        seed?: number,
        temperature?: number,
    }
): Promise<any> {
    const response = axios.post(`${host}/ai/generate`,
        {
            prompt: config.prompt,
            model: config.model ?? defaultModel,
            temperature: config.temperature ?? 0.7,
            type: config.type ?? 'text',
            seed: config.seed,
        },
        {headers: headers(config.projectId)})
    return response.then((response) => response.data)
}

export async function similaritySearch(
    config: {
        project?: string,
        query: string,
        where?: Where,
        whereDocument?: WhereDocument
    }
): Promise<any> {
    const response = axios.post(`${host}/ai/embeddings/search`,
        {
            project: 'project-' + config.project,
            query: config.query,
            where: config.where,
            whereDocument: config.whereDocument
        },
        {headers: headers(config.project)})
    return response.then((response) => response.data)
        .catch((error => ({documents: [], ids: [], distances: []})))
}

export async function embed(
    config: {
        project?: string,
        id: string,
        text: string,
        metadata?: Record<string, string | number | boolean>,
        chunkSize?: number,
        chunkOverlap?: number
    }
): Promise<any> {

    const response = axios.post(`${host}/ai/embeddings/create`,
        {
            project: 'project-' + config.project,
            id: config.id,
            content: config.text,
            metadata: config.metadata,
            chunkSize: config.chunkSize ?? 800,
            chunkOverlap: config.chunkOverlap ?? 0
        },
        {headers: headers(config.project)})
    return response.then((response) => response.data)
}

export async function getEmbedding(
    config: {
        project?: string,
        ids: string[],
    }
): Promise<any> {
    const response = axios.post(`${host}/ai/embeddings/get`,
        {
            project: 'project-' + config.project,
            ids: config.ids,
        },
        {headers: headers(config.project)})
    return response.then((response) => response.data)
}

export async function unembed(
    config: {
        project?: string,
        ids: string[],
    }
): Promise<any> {
    const response = axios.post(`${host}/ai/embeddings/delete`,
        {
            project: 'project-' + config.project,
            ids: config.ids,
        },
        {headers: headers(config.project)})
    return response.then((response) => response.data)
}

export const defaultModel = 'gpt-4o-mini'